export const camadasDiagnostico = [
    'TERRA_INDIGENA',
    'TERRA_INDIGENA_PARAGUAI',
    'PASTIZAL_INUNDABLE_PARAGUAI',
    'PASTIZAL_PARAGUAI',
    'AREA_EMBARGADA',
    'PRODES',
    'AREA_EMBARGADA_ICMBIO',
    'AREA_EMBARGADA_SEMA_MT',
    'AREA_EMBARGADA_GOIAS',
    'LISTA_AREA_EMBARGADA',
    'PROTOCOLO_VERDE_GRAOS',
    'LISTA_SUJA_TRABALHO_ESCRAVO',
    'AMAZONIA_PROTEGE',
    'LDI',
    'UNIDADE_CONSERVACAO_US',
    'UNIDADE_CONSERVACAO_PI',
    'PRODES_CERRADO',
    'PRODES_PANTANAL',
    'PRODES_MATA_ATLANTICA',
    'PRODES_PAMPA',
    'PRODES_CAATINGA',
    'DETER_AMAZONIA',
    'DETER_CERRADO',
    'DESMATAMENTO_INFONA_PARAGUAI',
    'DESMATAMENTO_INFONA_PARAGUAI_2020',
    'DESMATAMENTO_INFONA_PARAGUAI_2024',
    'QUEIMADAS',
    'SITIOS_ARQUEOLOGICOS',
    'INCRA_ASSENTAMENTOS',
    'INCRA_QUILOMBOLAS',
    'QUILOMBOLAS_MARANHAO',
    'DESMATAMENTO_MAPBIOMAS',
    'AREA_RELEVANTE_INTERESSE_ECOLOGICO_ARIE',
    'AREA_PROTECAO_AMBIENTAL_APA',
    'APP',
    'RESERVA_LEGAL',
    'UNIDADE_CONSERVACAO',
    'POVOS_COMUNIDADES_TRADICIONAIS',
    'AREA_EMBARGADA_SEDAM_RO',
    'LISTA_AREA_EMBARGADA_PIAUI',
    'AREAS_SILVESTRES_PROTEGIDAS_PARAGUAI',
    'AREA_EMBARGADA_PIAUI',
    'LISTA_AREA_EMBARGADA_SEMA_MT',
    'AREA_EMBARGADA_SIGA_MT_POLIGONO',
    'AREA_EMBARGADA_SIGA_MT_PONTO',
    'AREA_EMBARGADA_GDF',
    'FUNDACAO_PALMARES',
    'AUTO_INFRACAO_IPAAM',
    'TERMO_EMBARGO_IPAAM',
    'EMBARGOS_EMERGENCIAIS_IPAAM',
    'AUTOS_INFRACAO_FISCALIZACAO_IPAAM',
    'AUTO_INFRACAO_GO_PONTO',
    'EMBARGOS_REMOTOS_IPAAM',
    'AUTOS_EMBARGOS_IPAAM_POL',
    'RED_FLAG',
    'YELLOW_FLAG',
    'AREA_EMBARGADA_PARANA',
    'AREA_EMBARGADA_AUTO_INFRACAO_SP',
    'FLORESTAS_PUBLICAS',
    'AREA_EMBARGADA_RS',
    'AREA_EMBARGADA_GO_PONTO',
    'AUTO_INFRACAO_TO',
    'AREAS_EMBARGADAS_TO',
    'EMBARGOS_GO_LISTA',
    'PRODES_RESIDUOS',
    'PRODES_RESIDUOS_AMAZONIA',
    'PRODES_RESIDUOS_CAATINGA',
    'PRODES_RESIDUOS_CERRADO',
    'PRODES_RESIDUOS_MATA_ATLANTICA',
    'PRODES_RESIDUOS_PAMPA',
    'PRODES_RESIDUOS_PANTANAL',
    'AUTO_INFRACAO_RS',
    'QUILOMBOLAS_BA',
    'CSA_CERRADO',
    'AREA_EMBARGADA_PA',
    'AUTO_INFRACAO_PI',
    'EUDR_FOREST_COVER_2020',
    'SITIO_RAMSAR_PARAGUAI',
    'RESERVA_BIOSFERA_PARAGUAI',
    'RESERVA_PROVINCIALE',
    'PRODES_2008',
    'PRODES_2009',
    'PRODES_2010',
    'PRODES_2011',
    'PRODES_2012',
    'PRODES_2013',
    'PRODES_2014',
    'PRODES_2015',
    'PRODES_2016',
    'PRODES_2017',
    'PRODES_2018',
    'PRODES_2019',
    'PRODES_2020',
    'PRODES_2021',
    'PRODES_2022',
    'PRODES_2023',
    'PRODES_2024',
    'AREA_PLANTADA_DESMATAMENTO_VEGA_A_PARTIR_2021',
    'AREA_EMBARGADA_CE',
    'AREA_EMBARGADA_CE_PONTO',
    'AREA_EMBARGADA_IBAMA_POLIGONO_PAMGIA',
    'AREA_EMBARGADA_RO',
    'AREA_EMBARGADA_RO_PONTO',
    'DESMATAMENTO_ARGENTINA_2025',
    'PLANTIO_DESMATAMENTO_RED_FLAG',
    'CONTROLE_DESMATAMENTO_AMAZONIA',
    'CONTROLE_DESMATAMENTO_AMAZONIA_CONSOLIDADA',
    'CONTROLE_DESMATAMENTO_AMAZONIA_PONTOS',
    'SOJA_EM_PRODES_2425',
    'DESMATAMENTO_PARAGUAI_VEGA_2025',
    'DESMATAMENTO_VEGA_2025_COM_SOJA_2425_VEGA_PARAGUAI',
    'PROTOCOLO_VERDE_GRAOS_STATUS_OK',
    'PROTOCOLO_VERDE_GRAOS_STATUS_RESTRICAO',
    'TERRA_INDIGENA_STATUS_RESTRICAO',
    'TERRA_INDIGENA_STATUS_OK',
    'PASTIZAL_CONVERTIDO_A_CULTIVO_PARAGUAY',
    'DESMATAMENTO_PARAGUAI_VEGA',
    'DESMATAMENTO_PARAGUAI_VEGA_2025',
    'EMBARGOS_GO_INA_CONSULTA_LISTA',
    'AREA_PLANTADA_SOJA_PARAGUAI_2025_2026',
    'DENUNCIAS_PRODUTORES_BUNGE',
    'FOOTPRINT_BUNGE_MOINHO_TRIGO',
    'FOOTPRINT_BUNGE_SILOS',
    'FOOTPRINT_BUNGE_PORTO',
    'FOOTPRINT_BUNGE_FABRICA',
    'FOOTPRINT_BUNGE_EDIBLE',
    'AUTO_INFRACAO_GO_POLIGONO'
];
